
import Typography from "../typography/typography";
import Chip from "../chip/chip";
import images from '../../assets/images';
import { useState } from "react";
import { IconButton, MenuItem } from '@mui/material';
import Menu from '../menu/menu';
import { useTranslation } from 'react-i18next';
const DashBoardHeader = ({ title, customElement, showEdit = true, showDropDowan = true }) => {
    const { t } = useTranslation();
    //Local State
    const [isEditingMode, setIsEditingMode] = useState<boolean>(false);
    const [anchorMoreEl, setAnchorMoreEl] = useState<
        null | (EventTarget & HTMLButtonElement)
    >(null);




    const handleMoreIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorMoreEl(event.currentTarget);
    };

    const handleMoreIconClose = () => {
        setAnchorMoreEl(null);
    };

    //   const handleConfirm = () => {
    //     setIsDiscardModalOpen(false);
    //     setIsEditingMode(false);
    //   };

    //   const handleSaveChange = (event: SelectChangeEvent<unknown>) => {
    //     setIsEditingMode(false);
    //   };
    return (
        <div>
            <div className='header-title'>
                <Typography type='h3' weight={'medium'} color={'theme.secondary.1000'}>
                    {title}
                </Typography>
                <div className='header-right-wrap'>

                    {customElement}
                    {showEdit && <Chip
                        type='normal'
                        label={isEditingMode ? t('manufacturing.dashboard.editing_dashboard_mode_label') : t('manufacturing.dashboard.edit_layout_mode_label')}
                        className={`${isEditingMode ? 'edit-box' : 'edit-box edit-box--InActive'
                            }`}
                        icon={
                            <img
                                src={isEditingMode ? images.common.editIcon : images.edit}
                                alt={t('common.edit')}
                            />
                        }
                        onClick={() => setIsEditingMode(true)}
                        active={isEditingMode}
                    />
                    }
                    {
                        showDropDowan && <div>
                            <IconButton
                                color='inherit'
                                size='small'
                                onClick={handleMoreIconClick}>
                                <img src={images.more} alt={t('manufacturing.dashboard.more_icon_label')} />
                            </IconButton>
                            <Menu
                                anchorEl={anchorMoreEl}
                                open={Boolean(anchorMoreEl)}
                                onClose={handleMoreIconClose}
                                className='dropdown-inner calender-drp'>
                                <MenuItem onClick={handleMoreIconClose}>{t('common.export')}</MenuItem>
                            </Menu>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export { DashBoardHeader };
export default DashBoardHeader;
